import React from 'react';
import { TreePine, Building2, Sparkles, MapPin, Wallet, ShieldCheck, Eye } from 'lucide-react';
const items = [{
  label: 'Available Land Selling',
  icon: TreePine
}, {
  label: 'Estate Selling',
  icon: Building2
}, {
  label: 'New Estate Launch',
  icon: Sparkles
}, {
  label: 'Estate Tour',
  icon: MapPin
}, {
  label: 'Flexible Payment Plans',
  icon: Wallet
}, {
  label: 'Verified C of O & Titles',
  icon: ShieldCheck
}, {
  label: 'Free Site Inspection',
  icon: Eye
}];
export function MarqueeBand() {
  // Duplicate items so the loop is seamless
  const loop = [...items, ...items, ...items];
  return <div className="relative bg-ink text-bone overflow-hidden border-y border-gold/20" data-id="element-546">
      <div className="flex whitespace-nowrap animate-marquee" data-id="element-547">
        {loop.map((item, i) => {
        const Icon = item.icon;
        return <div key={i} className="flex items-center gap-3 px-8 py-3 shrink-0" data-id="element-548">
              <Icon className="w-3.5 h-3.5 text-gold shrink-0" strokeWidth={2} data-id="element-549" />
              <span className="text-[11px] sm:text-xs font-semibold tracking-[0.18em] uppercase text-bone/90" data-id="element-550">
                {item.label}
              </span>
              <span className="text-gold/60 text-xs ml-3" data-id="element-551">✦</span>
            </div>;
      })}
      </div>

      {/* Edge fades */}
      <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-ink to-transparent" data-id="element-552" />
      <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-ink to-transparent" data-id="element-553" />
    </div>;
}